import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const kobeTrades: SeasonTrades[] = [
  {
    season: "2010/2011",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Emeka Okafor",
        gotInReturn: "Luke Ridnour, Marcus Camby",
      },
    ],
  },
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Paul Pierce",
        gotInReturn: "Luol Deng and Kevin Seraphin",
      },
    ],
  },
  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.nissim,
        sentAway: "Tyson Chandler",
        gotInReturn: "Kevin Martin",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "DeMar DeRozan",
        gotInReturn: "Marc Gasol and Chandler Parsons",
      },
    ],
  },

  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Gorgui Dieng",
        gotInReturn: "Robin Lopez",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Rudy Gay",
        gotInReturn: "Joakim Noah and Tobias Harris",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Marcus Smart",
        gotInReturn: "Enes Kanter",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Marc Gasol and Derrick Rose",
        gotInReturn: "Al Horford and Jeff Teague",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Hassan Whiteside",
        gotInReturn: "Kyle Lowry, Ed Davis and Ben McLemore",
      },
      {
        otherTeam: manager.alon,
        sentAway: "Kyle Lowry",
        gotInReturn: "Reggie Jackson",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Ben McLemore",
        gotInReturn: "Nicolas Batum",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Serge Ibaka and Julius Randle",
        gotInReturn: "DeAndre Jordan and Zach LaVine",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Rodney Hood",
        gotInReturn: "Dirk Nowitzki and Rudy Gay",
        amongBestTrades: true
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Rudy Gay",
        gotInReturn: "Dwight Howard",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Deron Williams",
        gotInReturn: "Wesley Matthews",
      },
      {
        otherTeam: manager.alon,
        sentAway: "DeAndre Jordan",
        gotInReturn: "Stanley Johnson",
        amongWorstTrades: true
      },
    ],
  },
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "3rd round pick",
        gotInReturn: "Jabari Parker and 5th round pick"
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Ryan Anderson",
        gotInReturn: "Derrick Rose"
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Serge Ibaka and Harrison Barnes",
        gotInReturn: "DeAndre Jordan and Bismack Biyombo"
      }
    ]
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.oded,
        sentAway: "Bobby Portis",
        gotInReturn: "Larry Nance Jr"
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Goran Dragic", 
        gotInReturn: "Reggie Jackson and Andrew Wiggins"
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Khris Middleton", 
        gotInReturn: "Kristaps Porzingis"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jeff Teague",
        gotInReturn: "Jrue Holiday and Gary Harris" 
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Kyle Kuzma",
        gotInReturn: "Khris Middleton",
        amongBestTrades: true
      },
      {
        otherTeam: manager.idan,
        sentAway: "DeAndre Jordan",
        gotInReturn: "Lou Williams"
      }
    ]
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Caris LeVert",
        gotInReturn: "Malcolm Brogdon",
        amongBestTrades: true
      },
      
      {
        otherTeam: manager.yevgeny,
        sentAway: "Bobby Portis",
        gotInReturn: "Marvin Bagley"
      },
      {
        otherTeam: manager.idan,
        sentAway: "LeBron James",
        gotInReturn: "Donovan Mitchell",
        amongBestTrades: true
      },
      {
        otherTeam: manager.nissim,
        sentAway:"DeMarcus Cousins",
        gotInReturn: "Mo Bamba" 
      },
      
      
    ]
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Rui Hachimura",
        gotInReturn: "Joe Ingles"
      },
      {
        otherTeam: manager.idan,
        sentAway: "Brandon Ingram and Reggie Bullock",
        gotInReturn: "Khris Middleton and Gordon Hayward"
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Kristaps Porzingis",
        gotInReturn: "Draymond Green",
        amongWorstTrades: true
      }
      
    ]
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.ilya,
        sentAway: "Christian Wood",
        gotInReturn: "Jerami Grant",
        amongBestTrades: true
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Khris Middleton",
        gotInReturn: "Shai Gilegeous-Alexander",
        amongBestTrades: true
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Julius Randle and 3rd round pick",
        gotInReturn: "Nerlens Noel and 2nd round pick",
        amongBestTrades: true
      }  
    ]
  },
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Jusuf Nurkic",
        gotInReturn: "Lonzo Ball and Isaiah Stewart"
      },     
    ]
},
{
  season: "2022/23",
  allTrades: [
    {
      otherTeam: manager.ariel,
      sentAway: "Shai Gilgeous-Alexander",
      gotInReturn: "Giannis Antetokounmpo",
      amongWorstTrades: true
    },
    {
      otherTeam: manager.yevgeny,
      sentAway: "Ja Morant and Harrison Barnes",
      gotInReturn: "Jalen Duren and D'Angelo Russell",
      amongBestTrades: true
    }
  ]
},
{
  season: "2023/24",
  allTrades: [
    {
      otherTeam: manager.mati,
      sentAway: "Lauri Markkanen",
      gotInReturn: "Trey Murphy"
    },
  ]
},
{ season: "2024/25", allTrades: [] }
];
